// 活动列表数据
export const activityListData = ["优惠满999减200", "优惠满599减100", "优惠满299减50", "优惠满199减20", "优惠满99减5"];

// 轮播图数据
export const carouselData = [
  {
    img: require("@/assets/carousel-img/car4.jpg"),
    link: "",
  },
  // {
  //   img: require("@/assets/carousel-img/car2.jpg"),
  //   link: "",
  // },
  // {
  //   img: require("@/assets/carousel-img/car3.jpg"),
  //   link: "",
  // },
];

// 轮播图左侧菜单数据
export const sideMenuData = [
  {
    title: "美容清洁",
    item: [
      { name: "尾箱收纳", id: "goods2" },
      { name: "清洁工具", id: "goods4" },
    ],
  },
  {
    title: "养护配件",
    item: [
      { name: "防静电配件", id: "goods1" },
      { name: "电源配件", id: "goods11" },
    ],
  },
  {
    title: "安全自驾",
    item: [
      { name: "安全座椅", id: "goods6" },
      { name: "自驾装备", id: "goods15" },
    ],
  },
  {
    title: "车饰精品",
    item: [
      { name: "内饰精品", id: "goods14" },
      { name: "专车专用", id: "goods13" },
    ],
  },
  {
    title: "车载电器",
    item: [
      { name: "车载净化器", id: "goods12" },
      { name: "车载按摩椅", id: "goods16" },
    ],
  },
];

// 商品数据
export const goodsData = {
  goods5: {
    name: "goods5",
    details: "别克英朗座套真皮全包围 专用10-21款2015款别克新英朗精英版汽车座套坐垫四季通用座垫座椅套冬季 全包围玛莎皮【神秘黑】标准版 21 20 19 18 17-10款【英朗】定制",
    price: "698.00",
    coverImg: require("../assets/goods-img/goods5.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods5_1.jpg"),
      require("@/assets/goods-img/goods5_2.jpg"),
      require("@/assets/goods-img/goods5_3.jpg"),
      require("@/assets/goods-img/goods5_4.jpg"),
      require("@/assets/goods-img/goods5_5.jpg"),
      require("@/assets/goods-img/goods5_6.jpg"),
    ],
  },
  goods6: {
    name: "goods6",
    details: "汽车头枕腰靠套装 护颈枕车用座椅靠枕电动按摩记忆棉车内颈椎枕头腰靠 震动按摩款-经典黑【头枕+腰靠】",
    price: "185.00",
    coverImg: require("../assets/goods-img/goods6.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods6_1.jpg"),
      require("@/assets/goods-img/goods6_2.jpg"),
      require("@/assets/goods-img/goods6_3.jpg"),
      require("@/assets/goods-img/goods6_4.jpg"),
      require("@/assets/goods-img/goods6_5.jpg"),
      require("@/assets/goods-img/goods6_6.jpg"),
    ],
  },
  goods7: {
    name: "goods7",
    details: "汽车头枕护颈枕车用座椅靠枕电动按摩记忆棉车内颈椎枕头腰靠一对GK81 振动按摩款太空黑『头枕+腰靠』",
    price: "599.00",
    coverImg: require("../assets/goods-img/goods7.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods7_1.jpg"),
      require("@/assets/goods-img/goods7_2.jpg"),
      require("@/assets/goods-img/goods7_3.jpg"),
      require("@/assets/goods-img/goods7_4.jpg"),
      require("@/assets/goods-img/goods7_5.jpg"),
      require("@/assets/goods-img/goods7_6.jpg"),
    ],
  },
  goods8: {
    name: "goods8",
    details: "适用于汽车用品金属滚轮式汽车临时停车电话号码牌挪车移车停车卡内饰摆件 可用十年【炫酷黑】纯合金",
    price: "4.80",
    coverImg: require("../assets/goods-img/goods8.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods8_1.jpg"),
      require("@/assets/goods-img/goods8_2.jpg"),
      require("@/assets/goods-img/goods8_3.jpg"),
      require("@/assets/goods-img/goods8_4.jpg"),
      require("@/assets/goods-img/goods8_5.jpg"),
      require("@/assets/goods-img/goods8_6.jpg"),
    ],
  },
  goods1: {
    name: "goods1",
    details: "汽车静电消除器车载静电带车尾车上防静电接地带车用除静电神器去静电消除静电释放器汽车用品大全配件 【皮卡丘-黄底】静电带（轿车款）",
    price: "19.80",
    coverImg: require("@/assets/goods-img/goods1.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods1_1.jpg"),
      require("@/assets/goods-img/goods1_2.jpg"),
      require("@/assets/goods-img/goods1_3.jpg"),
      require("@/assets/goods-img/goods1_4.jpg"),
      require("@/assets/goods-img/goods1_5.jpg"),
      require("@/assets/goods-img/goods1_6.jpg"),
      require("@/assets/goods-img/goods1_7.jpg"),
    ],
  },
  goods2: {
    name: "goods2",
    details: "奔驰汽车后备箱储物箱收纳箱C级A级S级E级e300l/glc260gle级置物盒车用整理箱 【密码锁款大号】车标Mercedes-Benz",
    price: "578.00",
    coverImg: require("../assets/goods-img/goods2.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods2_1.jpg"),
      require("@/assets/goods-img/goods2_2.jpg"),
      require("@/assets/goods-img/goods2_3.jpg"),
      require("@/assets/goods-img/goods2_4.jpg"),
      require("@/assets/goods-img/goods2_5.jpg"),
      require("@/assets/goods-img/goods2_6.jpg"),
      require("@/assets/goods-img/goods2_7.jpg"),
    ],
  },
  goods3: {
    name: "goods3",
    details: "挪车电话牌 临时停车号码牌汽车移车电话牌 车载车上留双号码大数字滚动可隐藏式铝合金车内装饰用品",
    price: "33.60",
    coverImg: require("../assets/goods-img/goods3.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods3_1.jpg"),
      require("@/assets/goods-img/goods3_2.jpg"),
      require("@/assets/goods-img/goods3_3.jpg"),
      require("@/assets/goods-img/goods3_4.jpg"),
      require("@/assets/goods-img/goods3_5.jpg"),
      require("@/assets/goods-img/goods3_6.jpg"),
    ],
  },
  goods4: {
    name: "goods4",
    details: "汽车轮胎清石钩车胎清理勾石子清理工具 车载安全汽车用品大全车内饰品超市装饰新车配件车上黑科技 轮胎清石钩 1个装",
    price: "17.90",
    coverImg: require("../assets/goods-img/goods4.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods4_1.jpg"),
      require("@/assets/goods-img/goods4_2.jpg"),
      require("@/assets/goods-img/goods4_3.jpg"),
      require("@/assets/goods-img/goods4_4.jpg"),
      require("@/assets/goods-img/goods4_5.jpg"),
      require("@/assets/goods-img/goods4_6.jpg"),
    ],
  },

  goods9: {
    name: "goods9",
    details: "车载空气净化器杯座式便携式汽车内除味杀菌除甲醛烟味负离子净化器车载 典雅黑",
    price: "1580.00",
    coverImg: require("../assets/goods-img/goods9.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods9_1.jpg"),
      require("@/assets/goods-img/goods9_2.jpg"),
      require("@/assets/goods-img/goods9_3.jpg"),
      require("@/assets/goods-img/goods9_4.jpg"),
      require("@/assets/goods-img/goods9_5.jpg"),
      require("@/assets/goods-img/goods9_6.jpg"),
    ],
  },
  goods10: {
    name: "goods10",
    details: "2021新款运动亚麻汽车坐垫四季通用全包围布艺透气秋冬汽车座套座垫棉麻五座免拆安装汽车座椅套 A39米咖色-标准版-五座通用适用于 新轩逸经典轩逸逍客楼兰骊威骐达新天籁新奇骏",
    price: "328.00",
    coverImg: require("../assets/goods-img/goods10.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods10_1.jpg"),
      require("@/assets/goods-img/goods10_2.jpg"),
      require("@/assets/goods-img/goods10_3.jpg"),
      require("@/assets/goods-img/goods10_4.jpg"),
      require("@/assets/goods-img/goods10_5.jpg"),
      require("@/assets/goods-img/goods10_6.jpg"),
    ],
  },
  goods11: {
    name: "goods11",
    details: "汽车应急启动电源24v12v通用卡车大货车搭电宝车载电瓶充电器帮电救援打火神器 188000mAh-12v24v货车司机自用力荐",
    price: "538.00",
    coverImg: require("../assets/goods-img/goods11.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods11_1.jpg"),
      require("@/assets/goods-img/goods11_2.jpg"),
      require("@/assets/goods-img/goods11_3.jpg"),
      require("@/assets/goods-img/goods11_4.jpg"),
      require("@/assets/goods-img/goods11_5.jpg"),
      require("@/assets/goods-img/goods11_6.jpg"),
    ],
  },
  goods12: {
    name: "goods12",
    details: "太阳能车载空气净化器车内智能车用消除异味负离子汽车甲醛 珍珠白套餐二",
    price: "979.00",
    coverImg: require("../assets/goods-img/goods12.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods12_1.jpg"),
      require("@/assets/goods-img/goods12_2.jpg"),
      require("@/assets/goods-img/goods12_3.jpg"),
      require("@/assets/goods-img/goods12_4.jpg"),
      require("@/assets/goods-img/goods12_5.jpg"),
      require("@/assets/goods-img/goods12_6.jpg"),
    ],
  },
  goods13: {
    name: "goods13",
    details: "适用于英菲尼迪Q50L QX30 QX50改装电动折叠后视镜升级高配电动折耳一键升窗器加热镜片原厂 到厂安装预付定金安装调试好付尾款",
    price: "688.00",
    coverImg: require("../assets/goods-img/goods13.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods13_1.jpg"),
      require("@/assets/goods-img/goods13_2.jpg"),
      require("@/assets/goods-img/goods13_3.jpg"),
      require("@/assets/goods-img/goods13_4.jpg"),
      require("@/assets/goods-img/goods13_5.jpg"),
      require("@/assets/goods-img/goods13_6.jpg"),
    ],
  },
  goods14: {
    name: "goods14",
    details: "汽车挂件车载车内饰品出入平安符玉石挂饰男女高档后视镜装饰用品小车上香水吊坠 天然黑曜石-揽财双貔貅-平安福",
    price: "178.00",
    coverImg: require("../assets/goods-img/goods14.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods14_1.jpg"),
      require("@/assets/goods-img/goods14_2.jpg"),
      require("@/assets/goods-img/goods14_3.jpg"),
      require("@/assets/goods-img/goods14_4.jpg"),
      require("@/assets/goods-img/goods14_5.jpg"),
      require("@/assets/goods-img/goods14_6.jpg"),
    ],
  },
  goods15: {
    name: "goods15",
    details: "车用腿托腿部支撑延长垫后排休息脚踏板脚托车载搁脚凳翘腿凳 黑色款",
    price: "188.00",
    coverImg: require("../assets/goods-img/goods15.jpg"),
    detailsImg: [require("@/assets/goods-img/goods15_1.jpg"), require("@/assets/goods-img/goods15_2.jpg")],
  },
  goods16: {
    name: "goods16",
    details: "汽车加热坐垫冬季座椅按摩车载座垫四季通用 加热+按摩(5按摩头)黑色",
    price: "169.00",
    coverImg: require("../assets/goods-img/goods16.jpg"),
    detailsImg: [
      require("@/assets/goods-img/goods16_1.jpg"),
      require("@/assets/goods-img/goods16_2.jpg"),
      require("@/assets/goods-img/goods16_3.jpg"),
      require("@/assets/goods-img/goods16_4.jpg"),
      require("@/assets/goods-img/goods16_5.jpg"),
      require("@/assets/goods-img/goods16_6.jpg"),
    ],
  },
};
